import { useEffect, useState } from "react";
import { CalendarBlank } from "@phosphor-icons/react";
import { api } from "../lib/api";

export default function CalendarPage() {
  const [embed, setEmbed] = useState(null);

  useEffect(() => {
    api.get("/timeoff/calendar-embed").then((r) => setEmbed(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <p className="uppercase tracking-[0.2em] text-xs font-semibold text-indigo-600 mb-2">Schedule</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight flex items-center gap-3">
          <CalendarBlank size={30} weight="duotone" className="text-indigo-600" /> Team Calendar
        </h1>
        <p className="text-sm text-muted-foreground mt-2">Live Google Calendar — approved time off appears here automatically.</p>
      </div>

      <div className="bg-card border border-border rounded-md overflow-hidden" data-testid="google-calendar-embed">
        {embed === null && <p className="px-6 py-10 text-sm text-muted-foreground">Loading calendar…</p>}
        {embed && !embed.configured && <p className="px-6 py-10 text-sm text-muted-foreground">Google Calendar isn't connected yet.</p>}
        {embed?.configured && (
          <iframe
            title="Team Google Calendar"
            src={embed.embed_src}
            style={{ border: 0 }}
            className="w-full h-[75vh] min-h-[480px] bg-white"
            frameBorder="0"
            scrolling="no"
          />
        )}
        <p className="px-4 sm:px-6 py-3 text-xs text-muted-foreground border-t border-border flex flex-wrap items-center justify-between gap-2">
          <span>If the calendar looks empty, sign into a Google account this calendar is shared with.</span>
          {embed?.configured && (
            <a data-testid="open-google-calendar-link" href={embed.embed_src.replace("/embed?src=", "/u/0/r?cid=").split("&")[0]}
              target="_blank" rel="noreferrer" className="text-indigo-600 hover:underline font-medium">
              Open in Google Calendar →
            </a>
          )}
        </p>
      </div>
    </div>
  );
}
